// https://stackoverflow.com/a/9776795
export const divideDistribute = (num: number, divider: number) => {
  const values = [];
  while (num > 0 && divider > 0) {
    let divded = Math.floor(num / divider);
    num -= divded;
    divider--;
    values.push(divded);
  }
  return values;
};
